import { QueueWaitOfferThresholdsBuilder, QueueWaitOfferOptionsBuilder, QueueWaitOfferBuilder } from '../..';
import { VoiceMessageBuilder } from '../../..';
var DeprecatedWaitOfferSettingsBuilder = /** @class */ (function () {
    function DeprecatedWaitOfferSettingsBuilder() {
        this.waitOfferSettings = {
            enabled: false,
            queueWaitOfferThresholds: new QueueWaitOfferThresholdsBuilder().build(),
            waitOfferMessage: new VoiceMessageBuilder().build(),
            waitOfferOptions: [new QueueWaitOfferBuilder().build()],
            // will be deprecated
            queueWaitOfferOptions: new QueueWaitOfferOptionsBuilder().build()
        };
    }
    DeprecatedWaitOfferSettingsBuilder.prototype.withEnabled = function (enabled) {
        this.waitOfferSettings.enabled = enabled;
        return this;
    };
    DeprecatedWaitOfferSettingsBuilder.prototype.withQueueWaitOfferThresholds = function (queueWaitOfferThresholds) {
        this.waitOfferSettings.queueWaitOfferThresholds = queueWaitOfferThresholds;
        return this;
    };
    DeprecatedWaitOfferSettingsBuilder.prototype.withQueueWaitOfferMessage = function (waitOfferMessage) {
        this.waitOfferSettings.waitOfferMessage = waitOfferMessage;
        return this;
    };
    DeprecatedWaitOfferSettingsBuilder.prototype.withQueueWaitOffer = function (waitOfferOptions) {
        this.waitOfferSettings.waitOfferOptions = waitOfferOptions;
        return this;
    };
    DeprecatedWaitOfferSettingsBuilder.prototype.build = function () {
        return this.waitOfferSettings;
    };
    return DeprecatedWaitOfferSettingsBuilder;
}());
export { DeprecatedWaitOfferSettingsBuilder };
//# sourceMappingURL=wait-offer-options.builder.js.map